export const educationData = [
    {
        id: 1,
        institution: 'Ista al adarissa',
        course: 'Technicien spécialisé en développement digital',
        startYear: '',
        endYear: '2024'
    },
    {
        id: 2,
        institution: 'FSJES FES',
        course: 'LICENCE FONDAMENTALE SCIENCE ECONOMIE ET GESTION',
        startYear: '',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'FSJES FES',
        course: 'DEUG SCIENCE ECONOMIE ET GESTION',
        startYear: '',
        endYear: '2020'
    },
    {
        id: 4,
        institution: 'Lycée allal elfassi',
        course: 'Bac physique',
        startYear: '',
        endYear: '2016'
    },
]